import { MultiView } from "./multi-view.js";
import { styles } from "./multi-view.styles.js";
import { template } from "./multi-view.template.js";
import { DesignSystem } from "../design-system.js";
/**
 *
 * @public
 * @remarks
 * HTML Element: <fabric-multi-view>
 */
export const definition = MultiView.compose({
    name: `${DesignSystem.prefix}-multi-view`,
    template,
    styles,
    shadowOptions: {
        mode: DesignSystem.shadowRootMode
    }
});
//# sourceMappingURL=multi-view.definition.js.map